<div class="section-list">
  <div
    *ngFor="let section of sections; let i = index"
    class="section-item"
    (click)="navigateToSection(section.id)"
    [title]="section.title || '(No Section title)'"
  >
    <div class="section-number">{{ i + 1 }}</div>
    <div class="section-info">
      <div class="section-title">
        {{ section.title || '(No Section title)' }}
      </div>
      <div class="section-hint" *ngIf="section.hint">
        {{ section.hint }}
      </div>
    </div>
    <i class="pi pi-chevron-right section-arrow"></i>
  </div>
</div>
